/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */
const CONFIG_URL = 'https://app.sequoia.fitness/api/analytics/config';
const CACHE_KEY = 'sequoia.analytics-config-cache';
const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
let pending = null;

function readCache() {
  try {
    const raw = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (raw && Date.now() - raw.t < CACHE_TTL_MS && raw.d && 'clarity_id' in raw.d) return raw.d;
  } catch {}
  return null;
}

export function loadAnalyticsConfig() {
  const cached = readCache();
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = fetch(CONFIG_URL, { credentials: 'omit' })
      .then((res) => res.json())
      .then((json) => {
        const data = json?.data ?? json ?? {};
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch {}
        return data;
      });
  }
  return pending;
}
